<template>
  <div>
    <div class="px-3 py-2" :style="`direction:${lang.dir}`">
      <b-sidebar
        aria-labelledby="sidebar-no-header-title"
        width="90%"
        no-header
        id="car_contract_view"
        backdrop
        style="direction: ltr"
        right
        title="add order"
        shadow
      >
        <template #default="{ hide }">
          <div class="m-1 text-start" style="direction:rtl">
            <div
              style="
                width: 150px;
                margin-right: 10px;
                background: #000;
                color: #fff;
                border-radius: 5px;
              "
              class="btn-primary btn-sm text-center"
            >
              <span style="font-size: 0.8em"> {{ Number(project.con_type) === 2 ? (lang.dir === 'rtl' ? 'عقد تأمين' : 'Insurance contract') : lang.maint_contract }} </span>
            </div>
            <div
              @click="hide"
              id="vproconclose"
              style="
                width: 130px;
                text-align: center;
                float: left;
                margin-left: 5px;
                margin-top: -25px;
                cursor: pointer;
              "
              class="btn-danger btn-sm"
            >
              <span>{{ $parent.lang.close }}</span>
            </div>
          </div>
          <v-divider></v-divider>
          <p v-if="readError" class="m-2">{{lang.contract_load_failed}}</p>
          <p v-if="loading" class="m-2">{{lang.contract_loading}}</p>
          <v-row v-if="!loading && !readError && Number(project.contract_id)===id" style="direction: rtl" class="m-2">
            <v-col cols="12">
              <div
                class="backBlack"
                style="padding: 0px; width: 100%; text-align: center"
              >

                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    border: 2px solid #fff !important;
                    width: 155px;
                    background: #444 !important;
                    font-size: 1.1rem;
                    color: #fff;"
                  @click="printContract(project.contract_id)"
                  >{{lang.print}}</b-button
                >
                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    border: 2px solid #fff !important;
                    width: 155px;
                    background: red !important;
                    font-size: 1.1rem;
                    color: #fff;"
                  @click="resetAllValues()"
                  v-b-toggle.add_new_card
                  >{{lang.add_new_card}}</b-button
                >
                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    border: 2px solid #fff !important;
                    width: 155px;
                    background: green !important;
                    font-size: 1.1rem;
                    color: #fff;"
                  @click="addInvoiceEd()"
                  v-b-toggle.add_invoice
                  >{{lang.add_invoice}}</b-button
                >
                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    border: 2px solid #fff !important;
                    width: 155px;
                    background: blue !important;
                    font-size: 1.1rem;
                    color: #fff;"
                  @click="addQuot()"
                  v-b-toggle.add_quotation
                  >{{lang.add_quotation}}</b-button
                >
              </div>
              <div class="p-2 text-center" aria-live="polite">
                <p v-if="!project.notification_available">{{notificationText('contract_notification_unavailable')}}</p>
                <p v-else-if="project.notification_state && project.notification_state !== 'none'">
                  {{notificationText(project.notification_state)}}
                  <span v-if="project.notification_state === 'scheduled'">{{project.notification_scheduled_date}}</span>
                  <span v-else-if="project.notification_state === 'sent'">{{project.notification_provider_sent_date}}</span>
                  <span v-else-if="project.notification_state === 'queued'">{{project.notification_queued_date}}</span>
                </p>
                <div v-if="project.notification_available && ['none','scheduled'].includes(project.notification_state || 'none')">
                  <input type="date" v-model="notificationDate" :aria-label="notificationText('date')" class="inborder" style="margin-inline-end:8px" />
                  <b-button size="sm" variant="success" :disabled="notificationBusy || readError || loading" @click="sendNotification()">
                    {{notificationText(notificationDate ? 'schedule' : 'send')}}
                  </b-button>
                </div>
                <p v-if="notificationMessage" class="mt-2" role="status">{{notificationMessage}}</p>
              </div>
              <!-- <b-button
                class="mytab1 btn btn-sm btn-default m-2"
                style="
                  border: 2px solid #fff !important;
                  width: 155px;
                  background: blue !important;
                  font-size: 1.1rem;
                  color: #fff;
                "
                @click="addQuot()"
                v-b-toggle.addContractCard
                >{{ lang.update }}</b-button
              > -->
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <div style="padding:5px;border:1px solid #bbb;margin-bottom:5px;" class="backBlack text-center">{{lang.contract_details}}</div>
                  <v-simple-table>
                    <thead>
                        <tr>
                            <th class="backBlack" :style="`width:100px`">{{ lang.contract_id }}</th>
                            <td>{{ project.contract_id }}</td>
                            <th class="backBlack" :style="`width:100px`">{{ lang.contract_date }}</th>
                            <!-- <td>{{ project.contract_date.substr(0,10) }}</td> -->
                            <td>{{ project.contract_date }}</td>
                            <th class="backBlack" :style="`width:100px`">{{ lang.start_date }}</th>
                            <td>{{ project.start_date }}</td>
                            <!-- <td>{{ project.start_date.substr(0,10) }}</td> -->
                        </tr>
                        <tr>
                            <th class="backBlack" :style="`width:100px`">{{ lang.expire_date }}</th>
                            <td>{{ project.expire_date }}</td>
                            <!-- <td>{{ project.expire_date.substr(0,10) }}</td> -->
                            <th class="backBlack" :style="`width:100px`">{{ lang.mobile }}</th>
                            <td>{{ (project.customer_contacts[0] || {}).mobile || '-' }}</td>
                            <th class="backBlack" :style="`width:100px`">{{ lang.customer_name }}</th>
                            <td>{{ project.customer_name }}</td>
                        </tr>
                    </thead>
                  </v-simple-table>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <div style="padding:5px;border:1px solid #bbb;margin-bottom:5px;" class="backBlack text-center">{{lang.invoices}}</div>
                  <v-simple-table>
                    <thead>
                        <tr>
                            <th class="backBlack text-center" :style="`width:100px`">{{ lang.total }}</th>
                            <th class="backBlack" :style="`width:100px`">{{ lang.vat }}</th>
                            <th class="backBlack text-center" :style="`width:100px`">{{ lang.ftotal }}</th>
                        </tr>
                        <tr>
                            <td>{{ project.total }}</td>
                            <td>{{ project.vat }}</td>
                            <td>{{ project.ftotal }}</td>
                        </tr>
                    </thead>
                  </v-simple-table>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <div style="padding:5px;border:1px solid #bbb;margin-bottom:5px;" class="backBlack text-center" v-if="project.con_type == 1">{{lang.contract_items}}</div>
                  <v-simple-table v-if="project.con_type == 1">
                    <thead>
                        <tr>
                            <th class="backBlack text-center" style="width:80px;">{{ lang.item_code }}</th>
                            <th class="backBlack">{{ lang.item_name }}</th>
                            <th class="backBlack text-center" style="width:80px;">{{ lang.item_price }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in project.contract_items" :key="index">
                            <td>{{ item.item_code }}</td>
                            <td>{{ item.item_name }}</td>
                            <td>{{ item.item_price }}</td>
                        </tr>
                    </tbody>
                  </v-simple-table>
                  <div style="padding:5px;border:1px solid #bbb;margin-bottom:5px;margin-top:5px;" class="backBlack text-center">{{lang.terms}}</div>
                  <v-simple-table v-for="(item,index) in project.contract_terms_titles" :key="index">
                    <thead>
                        <tr>
                          <th class="backBlack text-center">{{ item.title_name }}</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(itm,ind) in item.terms" :key="ind">
                            <td style="text-wrap: wrap;white-space: pre-line !important;text-align:start">
                              <div style="text-wrap: wrap;white-space: pre-line !important;text-align:start">{{ itm.terms }}</div>
                            </td>
                        </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <div style="padding:5px;border:1px solid #bbb;margin-bottom:5px;" class="backBlack text-center" v-if="project.con_type == 1">{{ lang.cars }}</div>
                  <v-simple-table v-if="project.con_type == 1">
                    <thead>
                        <tr>
                            <th class="backBlack" style="width:80px;">{{ lang.plate_number }}</th>
                            <th class="backBlack">{{ lang.vin_number }}</th>
                            <th class="backBlack">{{ lang.model }}</th>
                            <th class="backBlack">{{ lang.car_year }}</th>
                            <th class="backBlack">{{ lang.meter_car }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in project.cars" :key="index">
                            <td>{{ item.plate_number }}</td>
                            <td>{{ item.vin }}</td>
                            <td>{{ item.model }}</td>
                            <td>{{ item.manufacturing_year }}</td>
                            <td>{{ item.meter_car }}</td>
                        </tr>
                    </tbody>
                  </v-simple-table>

                  <div style="padding:5px;border:1px solid #bbb;margin-bottom:5px;margin-top:5px;" class="backBlack text-center">{{lang.job_cards}}</div>
                  <v-simple-table>
                    <thead>
                        <tr>
                            <th class="text-center backBlack">{{ lang.received_date }}</th>
                            <th class="text-center backBlack">{{ lang.total }}</th>
                            <th class="text-center backBlack">{{ lang.vat }}</th>
                            <th class="text-center backBlack">{{ lang.ftotal }}</th>
                            <th class="text-center backBlack">{{ lang.status }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in project.jobs_list" :key="index">
                            <td>{{ item.received_date }}</td>
                            <!-- <td>{{ item.created_date.substr(0,10) }}</td> -->
                            <td>{{ item.total }}</td>
                            <td>{{ item.vat }}</td>
                            <td>{{ item.ftotal }}</td>
                            <td class="text-center" >{{ item[`status_${lang.langname}`] }}</td>
                        </tr>
                    </tbody>
                  </v-simple-table>
                  <div style="padding:5px;border:1px solid #bbb;margin-bottom:5px;margin-top:5px;" class="backBlack text-center">{{lang.invocies}}</div>
                  <v-simple-table>
                    <thead>
                        <tr>
                            <th class="text-center backBlack">{{ lang.invoice_date }}</th>
                            <th class="text-center backBlack">{{ lang.total }}</th>
                            <th class="text-center backBlack">{{ lang.vat }}</th>
                            <th class="text-center backBlack">{{ lang.ftotal }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in project.invoices_list" :key="index">
                            <td>{{ item.inv_date }}</td>
                            <!-- <td>{{ item.created_date.substr(0,10) }}</td> -->
                            <td>{{ item.total }}</td>
                            <td>{{ item.vat }}</td>
                            <td>{{ item.ftotal }}</td>
                        </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </b-sidebar>
    </div>

    <addCarContractCard ref="addCarContractCard" />
    <carConractAddInvoice ref="addCarInvoice" />
    <carConractAddQuot ref="addQuot" />
  </div>
</template>

<script>
import axios from "axios";
import addCarContractCard from "@/components/addNewCard.vue";
import carConractAddInvoice from "@/components/addInvoice.vue";
import carConractAddQuot from "@/components/addQuotation.vue";
export default {
  components: {
    addCarContractCard,carConractAddInvoice,carConractAddQuot

  },
  data() {
    return {
      id: 0,
      loading:false,readError:false,readSerial:0,
      project: {
        customer_contacts: [{mobile: ''}]
      },
      notificationDate: '',
      notificationBusy: false,
      notificationMessage: '',
    };
  },
  computed: {
    lang: function(){
        if(this.$cookies.get(this.$store.state.LangCooki) != null){
            if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
            }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        }
        else if(this.$store.state.deflang == 'en'){
            return this.$store.state.lang.en;
        }
        else if(this.$store.state.deflang == 'ur'){
            return this.$store.state.lang.ur;
        }else{
            return this.$store.state.lang.ar;
        }
    },
    is_mobile: function(){
        return false;
    },
    Statics: function () {
      let t = {
        crmActions: {},
        crmStatus: {},
        crmType: {},
      };
      for (let i = 0; i < this.staticOption.length; i++) {
        if (this.staticOption[i].option_phrase == "crmActions") {
          t.crmActions[this.staticOption[i].value] = {
            id: this.staticOption[i].value,
            name_ar: this.staticOption[i].name_ar,
            name_en: this.staticOption[i].name_en,
            bgColor: this.staticOption[i].bgColor,
            color: this.staticOption[i].color,
          };
        } else if (this.staticOption[i].option_phrase == "crmStatus") {
          t.crmStatus[this.staticOption[i].value] = {
            id: this.staticOption[i].value,
            name_ar: this.staticOption[i].name_ar,
            name_en: this.staticOption[i].name_en,
            bgColor: this.staticOption[i].bgColor,
            color: this.staticOption[i].color,
          };
        } else if (this.staticOption[i].option_phrase == "crmType") {
          t.crmType[this.staticOption[i].value] = {
            id: this.staticOption[i].value,
            name_ar: this.staticOption[i].name_ar,
            name_en: this.staticOption[i].name_en,
            bgColor: this.staticOption[i].bgColor,
            color: this.staticOption[i].color,
          };
        }
      }
      return t;
    },
  },
  methods: {
    resetAllValues(){
      this.$refs.addCarContractCard.resetValues();
      this.$refs.addCarContractCard.getInvSettings();
      this.$refs.addCarContractCard.customer.customerid = this.project.customerid;
      this.$refs.addCarContractCard.customer.id = this.project.customerid;
      // console.log(this.project.customerid);
      this.$refs.addCarContractCard.getAllNameById(0);
      this.$refs.addCarContractCard.contract_id = this.id;
      this.$refs.addCarContractCard.$refs.firstCar.image = '';
    },
    resetAllValuesS(){
      // this.$refs.addCarContractCard.resetValues();
      // this.$refs.addCarContractCard.getInvSettings();
      // this.$refs.addCarContractCard.customer.customerid = this.project.customerid;
      // this.$refs.addCarContractCard.customer.id = this.project.customerid;
      // console.log(this.project.customerid);
      // this.$refs.addCarContractCard.getAllNameById(0);
      // this.$refs.addCarContractCard.contract_id = this.id;
    },
    addInvoiceEd(){
      this.$refs.addCarInvoice.resetCont();
      this.$refs.addCarInvoice.customer.customerid = this.project.customerid;
      this.$refs.addCarInvoice.contract_id = this.id;
      this.$refs.addCarInvoice.getAllNameById(0);
    },
    addQuot(){
        this.$refs.addQuot.contract_id = this.id;
        this.$refs.addQuot.contractOfferedItems = [];
        this.$refs.addQuot.contractAutoDetected = false;
        this.$refs.addQuot.id = 0;
        this.$refs.addQuot.tbrows = [];
        this.$refs.addQuot.car = {
                model: '',
                plate_number: '',
                color: '',
                made_year: ''
            }
        this.$refs.addQuot.newrow = {
                itemcode: '',
                description: '',
                item_name: '',
                qty: 1,
                item_price: 0,
                total: 0,
                vat: 0,
                ftotal: 0,
                plate_number: '',
                discount: '',
            }
        this.$refs.addQuot.cars = [{
                plate_number: '',
                color: '',
                model: '',
                made_year: '',
                workdes: '',
                vin: '',
            }]
        this.$refs.addQuot.customer.id=this.project.customerid;
        this.$refs.addQuot.customer.mobile=(this.project.customer_contacts[0] || {}).mobile || '';
        this.$refs.addQuot.customer.full_name='';
        this.$refs.addQuot.customer.cctype=2;
        this.$refs.addQuot.company.fullname='';
        this.$refs.addQuot.company.crt_number='';
        this.$refs.addQuot.company.vatid='';

        this.$refs.addQuot.changeCusType(1);
        this.$refs.addQuot.getName();

      },
    addNote() {
      this.$refs.addnotes.crm_id = this.id;
    },
    addTask() {
      this.$refs.addCarContractCard.contract_id = this.project.contract_id;
      this.$refs.addCarContractCard.serviceList = this.project.contract_items;
    },
    addInvoice() {
      this.$refs.addCarInvoice.contract_id = this.project.contract_id;
      this.$refs.addCarInvoice.serviceList = this.project.contract_items;
    },
    addQuotation() {
      this.$refs.addCarQuot.contract_id = this.project.contract_id;
      this.$refs.addCarQuot.serviceList = this.project.contract_items;
    },
    printContract(id) {
      if(this.loading || this.readError || !Number.isInteger(Number(id)) || Number(id)<1 || Number(id)!==Number(this.id) || Number(this.project.contract_id)!==Number(id)) return false;
      window.open("../api/print.php?contractid=" + Number(id), "_blank");
      return true;
    },
    async getContracts(id){
      if(!Number.isInteger(Number(id))||Number(id)<1)return false;
      if(this.id!==Number(id)){this.notificationMessage='';this.notificationDate='';}
      this.id=Number(id);const selected=this.id,serial=++this.readSerial;this.loading=true;this.readError=false;const post=new FormData();post.append('type','getCarContracts');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('defBranch',localStorage.getItem('defBranch'));post.append('data[id]',selected);
      try{const {data}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);if(this.id!==selected||serial!==this.readSerial)return false;
        const row=data.results?.data?.[0];if(Number(data.error?.number)!==200||Number(row?.contract_id)!==selected)throw new Error('invalid');this.project=row;this.notificationDate=row.notification_scheduled_date || '';return true;
      }catch(error){if(this.id===selected&&serial===this.readSerial){this.readError=true;this.$snotify.error(this.lang.contract_load_failed,this.lang.alert);}return false;}
      finally{if(serial===this.readSerial)this.loading=false;}
    },
    doComputer(id) {
      if (id == 0) {
        return this.lang.no_devices;
      } else if (id == 1) {
        return this.lang.yes_19;
      } else if (id == 2) {
        return this.lang.yes_24;
      }
    },
    notificationText(code){
      const messages={
        date:['تاريخ إشعار العقد','Contract notification date'],send:['إرسال إشعار للعميل','Queue customer notification'],schedule:['جدولة الإشعار','Schedule notification'],
        queued:['تمت إضافة الإشعار إلى قائمة الإرسال، ولم يُرسل بعد.','Notification queued; it has not been sent yet.'],
        scheduled:['الإشعار مجدول بتاريخ','Notification scheduled for'],sending:['جارٍ إرسال الإشعار.','The notification is being sent.'],
        sent:['أرسل موفر الخدمة الإشعار بتاريخ','Provider sent the notification at'],failed:['فشل إرسال الإشعار. راجع سجل الرسائل.','Notification failed. Check the message log.'],
        cancelled:['تم إلغاء الإشعار في سجل الرسائل.','Notification cancelled in the message log.'],
        legacy_recorded:['يوجد سجل إشعار سابق دون تأكيد حالة الإرسال.','A previous notification is recorded; its sending status is unconfirmed.'],
        unconfirmed:['تعذر تأكيد حالة الإشعار. راجع سجل الرسائل.','Notification status is unconfirmed. Check the message log.'],
        contract_notification_unavailable:['إشعارات العقود غير متاحة. تواصل مع مسؤول النظام.','Contract notifications are unavailable. Contact your administrator.'],
        contract_notification_date_invalid:['اختر تاريخاً صحيحاً اليوم أو في المستقبل.','Choose a valid date today or in the future.'],
        contract_customer_mobile_required:['أضف رقم اتصال صحيحاً للعميل أولاً.','Add a valid customer phone number first.'],
        contract_notification_template_unavailable:['قالب إشعار العقد فارغ أو معطل. راجع إعدادات الرسائل.','The contract template is empty or disabled. Check message settings.'],
        contract_notification_opted_out:['العميل أوقف استقبال الرسائل.','The customer opted out of messages.'],
        contract_notification_queue_failed:['تعذر إضافة الإشعار إلى قائمة الإرسال. راجع إعدادات الرسائل.','Could not queue the notification. Check message settings.'],
        contract_customer_not_found:['بيانات عميل العقد غير متاحة في هذا الفرع.','The contract customer is unavailable in this branch.'],
        contract_already_queued:['يوجد إشعار مسجل لهذا العقد. أعد تحميل البيانات وراجع سجل الرسائل.','This contract already has a notification. Reload and check the message log.'],
        contract_notification_failed:['تعذر تأكيد حفظ الإشعار. أعد تحميل حالة العقد قبل المحاولة مجدداً.','Notification could not be confirmed. Reload the contract status before retrying.']
      };
      return (messages[code] || messages.contract_notification_failed)[this.lang.dir==='rtl'?0:1];
    },
    async sendNotification() {
      if(this.notificationBusy || this.loading || this.readError || Number(this.project.contract_id)!==Number(this.id) || !this.project.notification_available) return false;
      this.notificationBusy=true;this.notificationMessage='';
      const selected=Number(this.id),serial=this.readSerial;
      const post=new FormData();post.append('defBranch',localStorage.getItem('defBranch'));post.append('type','sendContractNotification');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('data[contract_id]',selected);post.append('data[scheduled_date]',this.notificationDate || '');
      try{
        const {data}=await axios.post(this.$SAMCOTEC.r_path,post);const result=data?.results?.data;
        if(Number(data?.error?.number)!==200 || Number(result?.id)!==selected || !['queued','scheduled'].includes(result?.status) || (result.status==='queued' && (!Number.isInteger(Number(result.outbox_id)) || Number(result.outbox_id)<1))){const failure=new Error('invalid');failure.response={data};throw failure;}
        if(this.id!==selected || this.readSerial!==serial) return true;
        this.notificationMessage=this.notificationText(result.status);
        const refreshed=await this.getContracts(selected);
        if(refreshed && this.id===selected) this.notificationMessage='';
        return true;
      }catch(error){
        if(this.id===selected && this.readSerial===serial) this.notificationMessage=this.notificationText(error.response?.data?.error?.code || 'contract_notification_failed');
        return false;
      }finally{this.notificationBusy=false;}
    },
    async getStaticOp() {
      let post = new FormData();
      post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
      let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
      const path = this.$router.currentRoute.path;
      post.append("type", "getStaticOptions");
      post.append("auth", cook);
      post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
      post.append("data[test]", "1");
      const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
      if (response && response.data) {
        this.staticOption = response.data.results.data;
      }
    },
  },
  created() {
    this.getStaticOp();
  },
};
</script>
